import React from 'react';
import PropTypes from 'prop-types';

import {
    Text,
    Flex,
    Spacer,
} from '@zillow/constellation';

import {
    StyledDot,
    StyledInfoContainer,
} from './StyledComponents';

const propTypes = {
    infos: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const InfoList = ({
    infos,
}) => (
    <StyledInfoContainer>
        {infos.map((infoText, index) => (
            <Spacer key={`info-${index}`} paddingBottom="md">
                <Flex key={`info-${index}`} display="flex" alignItems="center">
                    <StyledDot />
                    <Text fontType="body">{infoText}</Text>
                </Flex>
            </Spacer>
        ))}
    </StyledInfoContainer>
);

InfoList.propTypes = propTypes;

export default InfoList;
